export default __webpack_public_path__ + "static/media/plurifonds_it.icon.c5acf3bb.svg";